import { initGridsSplitter } from './grids_splitter.js';

(function () {
  'use strict';

  var SOURCE_GRID = 'frm-journal-source-grid';
  var CONSUMED_GRID = 'frm-journal-consumed-grid';
  var DEST_GRID = 'frm-journal-destination-grid';
  var suppressVsChange = false;

  function num(v) {
    if (v === null || v === undefined) return 0;
    var n = Number(String(v).replace(/,/g, '').trim());
    return Number.isFinite(n) ? n : 0;
  }

  function round4(v) {
    return Math.round(num(v) * 10000) / 10000;
  }

  function round3(v) {
    return Math.round(num(v) * 1000) / 1000;
  }

  function formatAutoNumber(value, fallback) {
    if (value === null || value === undefined || value === '') return fallback == null ? '' : String(fallback);
    var raw = String(value).replace(/,/g, '').trim();
    if (!raw) return fallback == null ? '' : String(fallback);
    if (!Number.isFinite(Number(raw))) return raw;
    return raw.replace(/(\.\d*?[1-9])0+$/, '$1').replace(/\.0+$/, '');
  }

  function val(id) {
    var el = document.getElementById(id + '_input') || document.getElementById(id);
    if (!el) return '';
    if (el.type === 'checkbox') return el.checked ? '1' : '';
    return el.value || '';
  }

  function setVal(id, value) {
    var el = document.getElementById(id);
    if (el && el.type === 'checkbox') {
      el.checked = !!value;
      return;
    }
    var input = document.getElementById(id + '_input') || el;
    if (input) {
      input.value = value == null ? '' : value;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }
    var vs = document.getElementById(id);
    if (vs && typeof vs.setValueSilently === 'function') {
      vs.setValueSilently(value == null ? '' : String(value));
    } else if (vs && typeof vs.setValue === 'function') {
      vs.setValue(value == null ? '' : String(value));
    }
  }

  function textInput(id, value) {
    var input = document.getElementById(id);
    if (input) input.value = value == null ? '' : value;
  }

  function setEntryQtyUom(id, uom) {
    var label = String(uom || '').trim() || 'Qty';
    var el = document.getElementById(id);
    if (el) el.textContent = label;
  }

  function setEntrySourceQtyUom(uom) {
    setEntryQtyUom('entry_s_qty_uom', uom);
  }

  function setEntryDestinationQtyUom(uom) {
    setEntryQtyUom('entry_d_qty_uom', uom);
  }

  function clearEntryFields() {
    setVal('entry_dest_itemcode', '');
    setVal('entry_jobidmaster_id', '');
    setVal('entry_rackno', '');
    [
      'entry_batchno',
      'entry_s_nos',
      'entry_s_qty',
      'entry_d_nos',
      'entry_d_qty',
      'entry_length',
      'entry_width',
      'entry_thick',
      'entry_rate',
      'entry_tax_rate',
      'entry_item_remarks'
    ].forEach(function (id) {
      textInput(id, '');
    });
    var sourceApi = gridApi(SOURCE_GRID);
    if (sourceApi && typeof sourceApi.deselectAll === 'function') sourceApi.deselectAll();
    setEntrySourceQtyUom('');
    setEntryDestinationQtyUom('');
  }

  function setStockQty(value) {
    var normalized = value == null || value === '' ? '' : String(value);
    var stockValue = document.getElementById('stock_qty');
    var hiddenStock = document.querySelector('input[type="hidden"][name="stock_qty"]');
    var display = stockValue ? stockValue.closest('.relative') : null;
    if (hiddenStock) hiddenStock.value = normalized;
    if (stockValue) stockValue.textContent = normalized;
    if (display) display.classList.toggle('hidden', !normalized);
  }

  function gridApi(name) {
    return window['aggridApi:' + name] || null;
  }

  function rows(name) {
    var api = gridApi(name);
    var out = [];
    if (!api) return out;
    api.forEachNode(function (node) {
      if (node.data && !node.rowPinned) out.push(node.data);
    });
    return out;
  }

  function setRows(name, data) {
    var api = gridApi(name);
    if (!api) return;
    if (api.setGridOption) {
      api.setGridOption('rowData', data || []);
    } else if (api.setRowData) {
      api.setRowData(data || []);
    }
  }

  function resequence(name) {
    var api = gridApi(name);
    if (!api) return;
    var sr = 1;
    api.forEachNode(function (node) {
      if (!node.data || node.rowPinned) return;
      node.data.srno = sr++;
      if (node.updateData) node.updateData(node.data);
    });
  }

  function selectedRow(name) {
    var api = gridApi(name);
    if (!api) return null;
    if (api.getSelectedNodes) {
      var selected = api.getSelectedNodes();
      if (selected && selected.length) return selected[0].data;
    }
    var focused = api.getFocusedCell && api.getFocusedCell();
    if (focused && focused.rowIndex >= 0) {
      var node = api.getDisplayedRowAtIndex(focused.rowIndex);
      if (node && node.data && !node.rowPinned) return node.data;
    }
    return null;
  }

  function selectedRows(name) {
    var api = gridApi(name);
    if (!api || !api.getSelectedNodes) return [];
    return api.getSelectedNodes().map(function (node) { return node.data; }).filter(Boolean);
  }

  function isOffcutMode() {
    var offcut = document.getElementById('offcut');
    return !!(offcut && offcut.checked);
  }

  function virtualOptions(name) {
    var el = document.getElementById(name);
    if (!el) return [];
    if (el.tagName === 'SELECT') {
      return Array.prototype.map.call(el.options, function (opt) {
        return { label: opt.textContent || '', value: opt.value || '' };
      });
    }
    try {
      return JSON.parse(el.getAttribute('data-options') || '[]');
    } catch (_e) {
      return [];
    }
  }

  function setVirtualSilently(name, value) {
    var vs = document.getElementById(name);
    var hidden = document.getElementById(name + '_input');
    var normalized = value == null ? '' : String(value);
    if (hidden) hidden.value = normalized;
    if (!vs) return;
    if (vs.tagName === 'SELECT') {
      vs.value = normalized;
      return;
    }
    if (typeof vs.setValueSilently === 'function') vs.setValueSilently(normalized);
    else if (vs.virtualSelect && typeof vs.virtualSelect.setValueSilently === 'function') vs.virtualSelect.setValueSilently(normalized);
  }

  function selectRawMaterialType() {
    var raw = virtualOptions('stocktype_id').find(function (opt) {
      var label = String(opt.label || '').trim().toLowerCase();
      return label === 'rm' || label === 'raw material' || label === 'raw materials';
    });
    if (raw && raw.value !== undefined) setVirtualSilently('stocktype_id', raw.value);
  }

  function setGridColumnVisible(name, colId, visible) {
    var api = gridApi(name);
    if (!api) return;
    try {
      if (api.setColumnsVisible) api.setColumnsVisible([colId], visible);
      else if (api.setColumnVisible) api.setColumnVisible(colId, visible);
      else if (api.columnApi && api.columnApi.setColumnVisible) api.columnApi.setColumnVisible(colId, visible);
      else if (api.getColumnApi && api.getColumnApi().setColumnVisible) api.getColumnApi().setColumnVisible(colId, visible);
      if (api.refreshHeader) api.refreshHeader();
    } catch (_e) {}
  }

  function setSourceSelectionMode(clearSourceRows) {
    var offcut = isOffcutMode();
    var tools = document.getElementById('frm-journal-offcut-tools');
    var entrySection = document.getElementById('frm-journal-entry-section');
    if (tools) {
      tools.classList.toggle('hidden', !offcut);
      tools.classList.toggle('flex', offcut);
    }
    if (entrySection) entrySection.classList.toggle('hidden', offcut);
    setGridColumnVisible(SOURCE_GRID, 'sel', offcut);
    setGridColumnVisible(SOURCE_GRID, 'offcutno', offcut);
    if (offcut) {
      selectRawMaterialType();
    } else {
      var api = gridApi(SOURCE_GRID);
      if (api && api.deselectAll) api.deselectAll();
    }
    if (clearSourceRows) {
      setRows(SOURCE_GRID, []);
      setStockQty('');
      syncHidden();
    }
  }

  function selectedOrFocusedRowIndex(api) {
    if (!api) return -1;
    var selected = api.getSelectedNodes && api.getSelectedNodes()[0];
    if (selected && selected.rowIndex >= 0) return selected.rowIndex;
    var focused = api.getFocusedCell && api.getFocusedCell();
    if (focused && focused.rowIndex >= 0) return focused.rowIndex;
    return -1;
  }

  function flash(type, message) {
    if (typeof window.showFlashMessage === 'function') {
      window.showFlashMessage(null, type || 'warning', message, 5);
    } else {
      window.alert(message);
    }
  }

  function syncHidden() {
    var source = document.getElementById('frm_journal_sourceRows');
    var consumed = document.getElementById('frm_journal_consumedRows');
    var dest = document.getElementById('frm_journal_destinationRows');
    if (source) source.value = JSON.stringify(rows(SOURCE_GRID));
    if (consumed) consumed.value = JSON.stringify(rows(CONSUMED_GRID));
    if (dest) dest.value = JSON.stringify(rows(DEST_GRID));
  }

  function apiToken() {
    var input = document.querySelector('[name="apitoken"]');
    return input ? input.value : '';
  }

  function fetchJson(url, params) {
    var qp = new URLSearchParams(params || {});
    var token = apiToken();
    if (token) qp.set('apitoken', token);
    return fetch(url + '?' + qp.toString(), {
      credentials: 'same-origin',
      headers: { 'X-Requested-With': 'XMLHttpRequest' }
    }).then(function (res) { return res.json(); });
  }

  function setVirtualOptions(name, options, keepValue) {
    var vs = document.getElementById(name);
    var normalized = (options || []).map(function (opt) {
      return { label: String(opt.text || ''), value: String(opt.value || '') };
    });
    if (!vs) return;
    if (vs.tagName === 'SELECT') {
      vs.innerHTML = '<option value="">Select</option>' + normalized.map(function (opt) {
        var option = document.createElement('option');
        option.value = opt.value;
        option.textContent = opt.label;
        if (keepValue && String(keepValue) === opt.value) option.selected = true;
        return option.outerHTML;
      }).join('');
      if (!keepValue) vs.value = '';
      return;
    }
    vs.setAttribute('data-options', JSON.stringify(normalized));
    if (typeof vs.setOptions === 'function') {
      vs.setOptions(normalized);
    } else if (vs.virtualSelect && typeof vs.virtualSelect.setOptions === 'function') {
      vs.virtualSelect.setOptions(normalized);
    } else if (typeof window.initVirtualSelect === 'function') {
      window.initVirtualSelect(vs);
    }
    var hidden = document.getElementById(name + '_input');
    if (keepValue) {
      if (hidden) hidden.value = String(keepValue);
      if (typeof vs.setValueSilently === 'function') vs.setValueSilently(String(keepValue));
      else if (typeof vs.setValue === 'function') vs.setValue(String(keepValue));
    } else {
      if (hidden) hidden.value = '';
      if (typeof vs.reset === 'function') vs.reset();
    }
  }

  function selectedVirtualText(name) {
    var vs = document.getElementById(name);
    if (vs && vs.tagName === 'SELECT') {
      return vs.selectedIndex >= 0 ? vs.options[vs.selectedIndex].text : '';
    }
    if (vs && typeof vs.getDisplayValue === 'function') return vs.getDisplayValue();
    var hidden = document.getElementById(name + '_input');
    return hidden ? hidden.value : '';
  }

  function sourceTotalsByMrn(rowsList) {
    var used = {};
    rowsList.forEach(function (row) {
      var key = String(row.mrndetails_id || '');
      used[key] = (used[key] || 0) + num(row.qty);
    });
    return used;
  }

  function sourceRowAvailable(sourceRow) {
    var used = sourceTotalsByMrn(rows(CONSUMED_GRID));
    var key = String(sourceRow.mrndetails_id || '');
    return round4(num(sourceRow.allowqty || sourceRow.quantity) - (used[key] || 0));
  }

  function sourceToEntry(row) {
    if (!row) return;
    setEntrySourceQtyUom(row.uom);
    setEntryDestinationQtyUom(row.uom);
    setVal('entry_dest_itemcode', row.itemcode || '');
    textInput('entry_batchno', row.batchno || '');
    textInput('entry_length', formatAutoNumber(row.length, 0));
    textInput('entry_width', formatAutoNumber(row.width, 0));
    textInput('entry_thick', formatAutoNumber(row.thickness, 0));
    textInput('entry_rate', formatAutoNumber(row.rate, 0));
    textInput('entry_tax_rate', formatAutoNumber(row.tax_rate, 0));
    setVal('entry_jobidmaster_id', row.jobidmaster_id || '');
    setVal('entry_rackno', row.rackno || '');
    textInput('entry_item_remarks', '');
  }

  function paintGridRowHighlight(gridId, matchedNode) {
    var grid = document.getElementById(gridId);
    if (!grid) return;
    grid
      .querySelectorAll('.ag-row.frm-journal-row-selected--highlight')
      .forEach(function (rowEl) {
        rowEl.classList.remove('frm-journal-row-selected--highlight');
      });
    if (!matchedNode || matchedNode.rowIndex == null) return;
    var rowEl = grid.querySelector(
      '.ag-row[row-index="' + matchedNode.rowIndex + '"]'
    );
    if (rowEl) rowEl.classList.add('frm-journal-row-selected--highlight');
  }

  function paintSourceRowHighlight(matchedNode) {
    paintGridRowHighlight(SOURCE_GRID, matchedNode);
  }

  function clearSourceHighlight() {
    var api = gridApi(SOURCE_GRID);
    if (api && api.deselectAll) api.deselectAll();
    paintGridRowHighlight(SOURCE_GRID, null);
  }

  function highlightLinkedBySrno(otherGridId, srno) {
    var api = gridApi(otherGridId);
    if (!api || !api.forEachNode) return;
    var key = String(srno == null ? '' : srno);
    var matched = null;
    if (api.deselectAll) api.deselectAll();
    api.forEachNode(function (node) {
      if (!node || !node.data || node.rowPinned) return;
      if (String(node.data.srno || '') === key) {
        if (node.setSelected) node.setSelected(true);
        matched = node;
      }
    });
    paintGridRowHighlight(otherGridId, matched);
    if (matched && api.ensureIndexVisible) {
      api.ensureIndexVisible(matched.rowIndex);
    }
  }

  function selectSourceRow(row) {
    if (!row) return;
    var api = gridApi(SOURCE_GRID);
    if (!api || !api.forEachNode) return;
    var key = String(row.mrndetails_id || '');
    var matched = null;
    api.forEachNode(function (node) {
      if (!node || !node.data || node.rowPinned || !node.setSelected) return;
      if (String(node.data.mrndetails_id || '') === key) {
        node.setSelected(true);
        matched = node;
      }
    });
    paintSourceRowHighlight(matched);
  }

  window.frmJournalOnSourceSelectionChanged = function () {
    sourceToEntry(selectedRow(SOURCE_GRID));
  };

  // suppressRowClickSelection=true on the Material Receipts grid means a click
  // does not toggle row selection on its own — so when the user clicks a row,
  // we both load its values into Item Details AND move the blue selection to
  // the clicked row. Otherwise the highlight stays stuck on the auto-loaded
  // first row even though the entry panel reflects a different row.
  window.frmJournalOnSourceRowClicked = function (params) {
    if (!params || !params.data) return;
    sourceToEntry(params.data);
    if (isOffcutMode()) return;
    var api = gridApi(SOURCE_GRID);
    if (api && api.deselectAll) api.deselectAll();
    if (params.node && params.node.setSelected) {
      params.node.setSelected(true, true);
    }
    paintSourceRowHighlight(params.node);
    paintGridRowHighlight(CONSUMED_GRID, null);
    paintGridRowHighlight(DEST_GRID, null);
  };

  window.frmJournalOnGridChanged = function () {
    syncHidden();
  };

  // Consumed and Destination rows are paired by srno (see buildPair). Clicking
  // one should highlight its linked partner in the other grid, and clear the
  // Material Receipts highlight so the user can see only the linked pair.
  window.frmJournalOnConsumedRowClicked = function (params) {
    if (!params || !params.data) return;
    paintGridRowHighlight(CONSUMED_GRID, params.node);
    highlightLinkedBySrno(DEST_GRID, params.data.srno);
    clearSourceHighlight();
  };

  window.frmJournalOnDestinationRowClicked = function (params) {
    if (!params || !params.data) return;
    paintGridRowHighlight(DEST_GRID, params.node);
    highlightLinkedBySrno(CONSUMED_GRID, params.data.srno);
    clearSourceHighlight();
  };

  function buildPair(source, destInfo, opts) {
    opts = opts || {};
    var sQty = opts.sQty == null ? sourceRowAvailable(source) : num(opts.sQty);
    var dQty = opts.dQty == null ? sQty : num(opts.dQty);
    var sNos = opts.sNos == null ? num(source.nos) : num(opts.sNos);
    var dNos = opts.dNos == null ? sNos : num(opts.dNos);
    var consumedRows = rows(CONSUMED_GRID);
    var srno = consumedRows.length + 1;
    var consumedRate = num(source.rate);
    var consumedTax = num(source.tax_rate);
    var destinationRate = opts.rate == null ? consumedRate : num(opts.rate);
    var destinationTax = opts.tax == null ? consumedTax : num(opts.tax);
    var destItem = destInfo.itemcode || source.itemcode || '';
    var destName = destInfo.itemname || source.itemname || selectedVirtualText('entry_dest_itemcode') || '';
    var uom = destInfo.uom || source.uom || '';
    var length = opts.length == null ? num(source.length) : num(opts.length);
    var width = opts.width == null ? num(source.width) : num(opts.width);
    var thick = opts.thickness == null ? num(source.thickness) : num(opts.thickness);
    var sourceWarehouseName = source.warehouse_name || selectedVirtualText('source_warehouse_id') || '';
    var destWarehouseName = selectedVirtualText('dest_warehouse_id') || '';

    return {
      consumed: {
        srno: srno,
        itemcode: source.itemcode || '',
        itemname: source.itemname || '',
        jobid: source.jobid || selectedVirtualText('entry_jobidmaster_id') || '',
        mrn_no: source.mrn_no || '',
        batchno: source.batchno || '',
        uom: source.uom || '',
        qty: round4(sQty),
        nos: round4(sNos),
        rate: consumedRate,
        tax_rate: consumedTax,
        amount: round4(sQty * consumedRate),
        length: length,
        width: width,
        thickness: thick,
        offcut: source.offcut || 0,
        remarks: opts.remarks || '',
        rackno: source.rackno || '',
        warehouse_name: sourceWarehouseName,
        warehouse_id: source.warehouse_id || val('source_warehouse_id'),
        id: 0,
        mrndetails_id: source.mrndetails_id,
        currency: source.currency || 'INR',
        mf: source.mf || 1,
        main_uom: source.main_uom || '',
        alternate_uom: source.alternate_uom || '',
        alternate_mf: source.alternate_mf || source.mf || 1,
        stock_nos: source.stock_nos || 0
      },
      destination: {
        srno: srno,
        itemcode: destItem,
        itemname: destName,
        jobid: selectedVirtualText('entry_jobidmaster_id') || source.jobid || '',
        mrn_no: '',
        qty: round4(dQty),
        nos: round4(dNos),
        uom: uom,
        length: length,
        width: width,
        thickness: thick,
        rate: destinationRate,
        tax_rate: destinationTax,
        batchno: opts.batchno == null ? (source.batchno || '') : opts.batchno,
        remarks: opts.remarks || '',
        rackno: opts.rackno == null ? (source.rackno || '') : opts.rackno,
        warehouse_name: destWarehouseName,
        warehouse_id: val('dest_warehouse_id'),
        id: 0,
        offcut: source.offcut || 0,
        amount: round4(dQty * destinationRate),
        vendor_id: source.vendor_id || '',
        stock_nos: destInfo.stock_nos || source.stock_nos || 0,
        jobidmaster_id: val('entry_jobidmaster_id') || source.jobidmaster_id || '',
        currency: source.currency || 'INR',
        mf: destInfo.mf || source.mf || 1,
        main_uom: destInfo.main_uom || '',
        alternate_uom: destInfo.alternate_uom || '',
        alternate_mf: destInfo.alternate_mf || destInfo.mf || source.mf || 1,
        source_mrndetails_id: source.mrndetails_id,
        source_itemcode: source.itemcode || ''
      }
    };
  }

  function getDestinationInfo(itemcode) {
    if (!itemcode) return Promise.resolve({});
    return fetchJson('/ssr/journalssr/iteminfo', { itemcode: itemcode })
      .then(function (data) { return data.item || {}; })
      .catch(function () { return {}; });
  }

  var destUnitRequestSeq = 0;
  function refreshDestinationQtyUom() {
    var requestSeq = ++destUnitRequestSeq;
    var destItem = val('entry_dest_itemcode');
    if (!destItem) {
      setEntryDestinationQtyUom('');
      return;
    }
    getDestinationInfo(destItem).then(function (info) {
      if (requestSeq !== destUnitRequestSeq) return;
      var source = selectedRow(SOURCE_GRID);
      setEntryDestinationQtyUom(info.uom || (source && source.uom) || '');
    });
  }

  function addPair(pair) {
    var cApi = gridApi(CONSUMED_GRID);
    var dApi = gridApi(DEST_GRID);
    if (!cApi || !dApi) return false;
    cApi.applyTransaction({ add: [pair.consumed] });
    dApi.applyTransaction({ add: [pair.destination] });
    resequence(CONSUMED_GRID);
    resequence(DEST_GRID);
    syncHidden();
    return true;
  }

  function setAddButtonBusy(isBusy) {
    var btn = document.getElementById('frm-journal-add-row');
    if (!btn) return;
    btn.disabled = !!isBusy;
    btn.classList.toggle('htmx-request', !!isBusy);
  }

  var addEntryInFlight = false;
  function addEntryRow() {
    if (addEntryInFlight) return;
    var source = selectedRow(SOURCE_GRID);
    if (!source) {
      flash('warning', 'Please select a source material receipt row.');
      return;
    }
    var destItem = val('entry_dest_itemcode') || source.itemcode;
    var sQty = num(document.getElementById('entry_s_qty') && document.getElementById('entry_s_qty').value);
    var dQty = num(document.getElementById('entry_d_qty') && document.getElementById('entry_d_qty').value);
    if (sQty <= 0 || dQty <= 0) {
      flash('warning', 'Please Qty in source and destination quantity.');
      return;
    }
    var available = sourceRowAvailable(source);
    if (sQty > available + 0.0001) {
      flash('warning', 'Source quantity is greater than available quantity.');
      return;
    }
    if (dQty && Math.abs(sQty - dQty) / dQty > 0.05) {
      flash('warning', 'Be careful, the source and destination quantity differ by more than 5%.');
      return;
    }
    if (
      String(source.itemcode || '') === String(destItem || '') &&
      String(val('source_warehouse_id') || '') === String(val('dest_warehouse_id') || '') &&
      String(source.rackno || '') === String(val('entry_rackno') || '') &&
      num(source.length) === num(document.getElementById('entry_length') && document.getElementById('entry_length').value) &&
      num(source.width) === num(document.getElementById('entry_width') && document.getElementById('entry_width').value) &&
      num(source.thickness) === num(document.getElementById('entry_thick') && document.getElementById('entry_thick').value)
    ) {
      flash('warning', 'Destination row is same as source. Change item, warehouse, rack or specs.');
      return;
    }
    addEntryInFlight = true;
    setAddButtonBusy(true);
    getDestinationInfo(destItem).then(function (info) {
      var added = addPair(buildPair(source, info, {
        sQty: sQty,
        dQty: dQty,
        sNos: document.getElementById('entry_s_nos') && document.getElementById('entry_s_nos').value,
        dNos: document.getElementById('entry_d_nos') && document.getElementById('entry_d_nos').value,
        length: document.getElementById('entry_length') && document.getElementById('entry_length').value,
        width: document.getElementById('entry_width') && document.getElementById('entry_width').value,
        thickness: document.getElementById('entry_thick') && document.getElementById('entry_thick').value,
        rate: document.getElementById('entry_rate') && document.getElementById('entry_rate').value,
        tax: document.getElementById('entry_tax_rate') && document.getElementById('entry_tax_rate').value,
        batchno: document.getElementById('entry_batchno') && document.getElementById('entry_batchno').value,
        rackno: val('entry_rackno'),
        remarks: document.getElementById('entry_item_remarks') && document.getElementById('entry_item_remarks').value
      }));
      if (added) clearEntryFields();
    }).finally(function () {
      addEntryInFlight = false;
      setAddButtonBusy(false);
    });
  }

  function addSelectedRows() {
    if (!isOffcutMode()) return;
    if (String(val('source_warehouse_id') || '') === String(val('dest_warehouse_id') || '')) {
      flash('warning', 'Select different destination Warehouse.');
      return;
    }
    var selected = selectedRows(SOURCE_GRID);
    if (!selected.length) {
      flash('warning', 'Please select source rows.');
      return;
    }
    selected.forEach(function (source) {
      var available = sourceRowAvailable(source);
      if (available <= 0) return;
      addPair(buildPair(source, {
        itemcode: source.itemcode,
        itemname: source.itemname,
        uom: source.uom,
        stock_nos: source.stock_nos,
        mf: source.mf,
        main_uom: source.main_uom,
        alternate_uom: source.alternate_uom,
        alternate_mf: source.alternate_mf
      }, { sQty: available, dQty: available }));
    });
    var api = gridApi(SOURCE_GRID);
    if (api && api.deselectAll) api.deselectAll();
    syncHidden();
  }

  function deleteSelectedPair() {
    var cApi = gridApi(CONSUMED_GRID);
    var dApi = gridApi(DEST_GRID);
    if (!cApi || !dApi) return;
    var index = selectedOrFocusedRowIndex(cApi);
    if (index < 0) index = selectedOrFocusedRowIndex(dApi);
    if (index < 0) {
      flash('warning', 'Please select a consumed or destination row to delete.');
      return;
    }
    var cNode = cApi.getDisplayedRowAtIndex(index);
    var dNode2 = dApi.getDisplayedRowAtIndex(index);
    if (cNode && cNode.data) cApi.applyTransaction({ remove: [cNode.data] });
    if (dNode2 && dNode2.data) dApi.applyTransaction({ remove: [dNode2.data] });
    resequence(CONSUMED_GRID);
    resequence(DEST_GRID);
    syncHidden();
  }

  function refreshSourceRows() {
    if (suppressSourceRefresh) return;
    if (!isOffcutMode() && !val('source_itemcode')) {
      setRows(SOURCE_GRID, []);
      setStockQty('');
      syncHidden();
      return;
    }
    fetchJson('/ssr/journalssr/sourceitems', {
      id: val('id'),
      voucherdate: val('voucherdate'),
      source_warehouse_id: val('source_warehouse_id'),
      stocktype_id: val('stocktype_id'),
      group_id: val('group_id'),
      category_id: val('category_id'),
      source_itemcode: val('source_itemcode'),
      offcut: isOffcutMode() ? '1' : ''
    }).then(function (data) {
      var sourceRows = data.rows || [];
      setRows(SOURCE_GRID, sourceRows);
      var stock = sourceRows.reduce(function (acc, row) { return acc + num(row.quantity); }, 0);
      setStockQty(round4(stock));
      if (sourceRows.length) {
        sourceToEntry(sourceRows[0]);
        selectSourceRow(sourceRows[0]); 
      }
      syncHidden();
    }).catch(function () {
      flash('error', 'Unable to load material receipts.');
    });
  }

  function refreshGroups() {
    return fetchJson('/ssr/journalssr/groupoptions', {
      stocktype_id: val('stocktype_id')
    }).then(function (data) {
      setVirtualOptions('group_id', data.options || [], '');
      setVal('group_id', '');
      setVirtualOptions('category_id', [], '');
      setVal('category_id', '');
    });
  }

  function refreshCategories() {
    return fetchJson('/ssr/journalssr/categoryoptions', {
      stocktype_id: val('stocktype_id'),
      group_id: val('group_id')
    }).then(function (data) {
      setVirtualOptions('category_id', data.options || [], '');
      setVal('category_id', '');
    });
  }

  function refreshItems() {
    return fetchJson('/ssr/journalssr/itemoptions', {
      stocktype_id: val('stocktype_id'),
      group_id: val('group_id'),
      category_id: val('category_id')
    }).then(function (data) {
      setVirtualOptions('source_itemcode', data.options || [], val('source_itemcode'));
      setVirtualOptions('entry_dest_itemcode', data.options || [], val('entry_dest_itemcode'));
    });
  }

  function loadTerms() {
    var template = val('terms_template');
    if (!template) return;
    fetchJson('/ssr/journalssr/terms', { terms_template: template }).then(function (data) {
      var area = document.getElementById('termsconditions');
      if (area) {
        area.value = data.termsconditions || '';
        area.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });
  }

  function bindOnce(el, eventName, fn) {
    if (!el) return;
    var key = '__frmJournal_' + eventName;
    if (el[key]) return;
    el[key] = true;
    el.addEventListener(eventName, fn);
  }

  function bindVirtualChange(id, fn) {
    bindOnce(document.getElementById(id), 'change', fn);
    bindOnce(document.getElementById(id + '_input'), 'change', fn);
  }

  function calcQtyFromNos(nosInputId, qtyInputId) {
    var source = selectedRow(SOURCE_GRID);
    if (!source) return;
    var nosEl = document.getElementById(nosInputId);
    var qtyEl = document.getElementById(qtyInputId);
    var enteredNos = num(nosEl && nosEl.value);
    if (enteredNos <= 0 || !qtyEl) return;
    var stockNos = num(source.nos);
    var stockQty = num(source.quantity);
    if (stockNos > 0 && stockQty > 0) {
      qtyEl.value = round3((stockQty / stockNos) * enteredNos);
    } else if (stockQty > 0) {
      qtyEl.value = round3(stockQty * enteredNos);
    }
  }

  var currentLoadedId = '';
  var suppressSourceRefresh = false;

  function setValSilent(id, value) {
    var normalized = value == null ? '' : String(value);
    var hidden = document.getElementById(id + '_input');
    if (hidden) hidden.value = normalized;
    var el = document.getElementById(id);
    if (!el) return;
    if (el.type === 'checkbox') { el.checked = !!value; return; }
    if (typeof el.setValueSilently === 'function') el.setValueSilently(normalized);
    else if (el.tagName === 'SELECT') el.value = normalized;
    else if (el.tagName === 'INPUT' || el.tagName === 'TEXTAREA') el.value = normalized;
  }

  function applyVoucherData(data) {
    var saved = data.saveddata || {};
    var fieldIds = [
      'voucherdate', 'stocktype_id', 'source_warehouse_id', 'dest_warehouse_id',
      'co_vendor_id', 'source_itemcode', 'remarks', 'supplier_ref', 'ref_no',
      'gate_entry_no', 'eway_bill_no', 'transporter_vendor_id', 'transport_mode',
      'vehicle_type', 'vehicle_no', 'transport_docno', 'transport_docdate',
      'freight', 'gross_weight', 'net_weight', 'weight_slip_no', 'challan_no',
      'terms_template', 'termsconditions'
    ];
    fieldIds.forEach(function (name) {
      if (saved[name] !== undefined) setValSilent(name, saved[name]);
    });

    var idInput = document.querySelector('input[name="id"]');
    if (idInput) idInput.value = saved.id || 0;
    var transportIdInput = document.querySelector('input[name="transport_id"]');
    if (transportIdInput) transportIdInput.value = saved.transport_id || '';

    setStockQty(saved.stock_qty || '');

    var gridRows = data.rows || {};
    setRows(SOURCE_GRID, gridRows.source || []);
    setRows(CONSUMED_GRID, gridRows.consumed || []);
    setRows(DEST_GRID, gridRows.destination || []);
    if (gridRows.source && gridRows.source.length) {
      sourceToEntry(gridRows.source[0]);
      if (!isOffcutMode()) selectSourceRow(gridRows.source[0]);
    }
    syncHidden();
    currentLoadedId = String(saved.id || '');
    var newUrl = window.location.pathname + '?showview=dataform' +
      (saved.id ? '&id=' + saved.id : '');
    window.history.replaceState(null, '', newUrl);
  }

  var loadVoucherTimer = null;
  function loadVoucherByFetch(voucherId) {
    var landingUrl = window.location.pathname;
    var params = new URLSearchParams();
    params.set('showview', 'dataform');
    if (voucherId) params.set('id', String(voucherId));
    var apitoken = document.querySelector('[name="apitoken"]');
    if (apitoken && apitoken.value) params.set('apitoken', apitoken.value);
    var url = landingUrl + '?' + params.toString();
    var newUrl = window.location.pathname + '?showview=dataform' + (voucherId ? '&id=' + voucherId : '');
    if (window.htmx) {
      window.htmx.ajax('GET', url, { target: 'body', swap: 'none' })
        .then(function () {
          try { window.history.replaceState(null, '', newUrl); } catch (_e) {}
          currentLoadedId = String(voucherId || '');
        })
        .catch(function () { flash('error', 'Unable to load the selected voucher.'); });
    } else {
      window.location.href = newUrl;
    }
  }

  function navigateToVoucher() {
    var selected = val('voucher_no');
    if (!selected || selected === 'New') {
      if (!currentLoadedId) return;
      if (loadVoucherTimer) clearTimeout(loadVoucherTimer);
      loadVoucherTimer = setTimeout(function () { loadVoucherByFetch(''); }, 50);
      return;
    }
    if (selected === currentLoadedId) return;
    if (loadVoucherTimer) clearTimeout(loadVoucherTimer);
    loadVoucherTimer = setTimeout(function () { loadVoucherByFetch(selected); }, 50);
  }

  function bind() {
    if (!document.querySelector('[data-formname="journalssr"]')) return;
    currentLoadedId = new URLSearchParams(window.location.search).get('id') || '';
    bindVirtualChange('voucher_no', navigateToVoucher);
    bindOnce(document.getElementById('frm-journal-add-row'), 'click', function (evt) {
      if (evt) {
        evt.preventDefault();
        evt.stopPropagation();
      }
      addEntryRow();
    });
    bindOnce(document.getElementById('frm-journal-add-selected'), 'click', addSelectedRows);
    bindOnce(document.getElementById('frm-journal-delete-row'), 'click', deleteSelectedPair);
    bindOnce(document.getElementById('frm-journal-refresh-source'), 'click', refreshSourceRows);
    bindOnce(document.getElementById('offcut'), 'change', function () {
      setSourceSelectionMode(true);
    });

    bindOnce(document.getElementById('entry_s_nos'), 'input', function () {
      calcQtyFromNos('entry_s_nos', 'entry_s_qty');
    });
    bindOnce(document.getElementById('entry_d_nos'), 'input', function () {
      calcQtyFromNos('entry_d_nos', 'entry_d_qty');
    });

    ['voucherdate', 'source_warehouse_id', 'source_itemcode'].forEach(function (id) {
      var el = document.getElementById(id) || document.getElementById(id + '_input');
      bindOnce(el, 'change', refreshSourceRows);
    });

    bindVirtualChange('stocktype_id', function () {
      if (suppressVsChange) return;
      suppressVsChange = true;
      refreshGroups().then(refreshItems).finally(function () { suppressVsChange = false; });
    });
    bindVirtualChange('group_id', function () {
      if (suppressVsChange) return;
      suppressVsChange = true;
      refreshCategories().then(refreshItems).finally(function () { suppressVsChange = false; });
    });
    bindVirtualChange('category_id', function () {
      if (suppressVsChange) return;
      refreshItems();
    });
    bindVirtualChange('entry_dest_itemcode', refreshDestinationQtyUom);
    bindVirtualChange('terms_template', loadTerms);
    setSourceSelectionMode(false);
    setTimeout(function () { setSourceSelectionMode(false); }, 100);
    syncHidden();
  }

  window.selectOrdersToApprove = function (arg) {
    try {
      var api =
        arg && arg.api && typeof arg.api.getSelectedRows === 'function'
          ? arg.api
          : null;
      var domEl = arg && arg.dataset ? arg : null;
      if (!api && domEl && domEl.dataset && domEl.dataset.agId) {
        api = window['aggridApi:' + domEl.dataset.agId] || null;
      }
      if (!domEl && api) {
        var hosts = document.querySelectorAll('[data-ag-id]');
        for (var i = 0; i < hosts.length; i++) {
          if (window['aggridApi:' + hosts[i].dataset.agId] === api) {
            domEl = hosts[i];
            break;
          }
        }
      }
      var selected = api ? (api.getSelectedRows() || []) : [];
      if (domEl && domEl.dataset) {
        domEl.dataset.selectedRows = JSON.stringify(selected);
      }
    } catch (_err) {
      // ignore
    }
  };

  window.journalChallanPreview = function (btn) {
    var backBtn = document.getElementById('dataform-backButton');
    if (backBtn && backBtn.parentNode) {
      backBtn.parentNode.insertBefore(btn, backBtn);
    }
    if (btn.dataset.journalChallanBound) return;
    btn.dataset.journalChallanBound = '1';
    btn.addEventListener('click', function () {
      var url = btn.dataset.challanUrl;
      var recordId = btn.dataset.recordId;
      if (!url || !recordId) return;

      var tokenEl = document.querySelector('[name="apitoken"]');
      var fd = new FormData();
      fd.append('id', recordId);
      if (tokenEl && tokenEl.value) fd.append('apitoken', tokenEl.value);

      window.setPrintButtonLoading?.(btn, true);
      fetch(url, { method: 'POST', body: fd, credentials: 'same-origin' })
        .then(function (resp) {
          if (!resp.ok) throw new Error('Challan PDF failed: ' + resp.status);
          return resp.blob();
        })
        .then(function (blob) {
          if (window.showPreview) {
            return Promise.resolve(window.showPreview(blob, 'delivery_challan.pdf'));
          }
        })
        .catch(function (err) {
          flash('error', (err && err.message) || 'Failed to generate challan PDF.');
        })
        .finally(function () { window.setPrintButtonLoading?.(btn, false); });
    });
  };

  window.frmJournalInit = bind;
  document.addEventListener('DOMContentLoaded', bind);
  document.addEventListener('htmx:afterSettle', bind);
  document.addEventListener('htmx:configRequest', function (evt) {
    var trigger = evt.detail && evt.detail.elt;
    if (
      !document.querySelector('[data-formname="journalssr"]') ||
      !trigger ||
      trigger.id !== 'standard-save-button'
    ) return;
    var consumedEl = document.getElementById('frm_journal_consumedRows');
    var destinationEl = document.getElementById('frm_journal_destinationRows');
    var sourceEl = document.getElementById('frm_journal_sourceRows');
    syncHidden();
    evt.detail.parameters.consumedRows = (consumedEl && consumedEl.value) || '[]';
    evt.detail.parameters.destinationRows = (destinationEl && destinationEl.value) || '[]';
    evt.detail.parameters.sourceRows = (sourceEl && sourceEl.value) || '[]';
  });

  // Drag-to-resize splitter between Consumed (left) and Destination (right) grids.
  initGridsSplitter({
    prefix: 'jr',
    minBreakpointPx: 1280,
    minRatio: 0.20,
  });
})();
